import VueDOMPurifyHTML from "vue-dompurify-html";
import apolloClient from "@/src/shared/plugins/apolloClient";
import { AnyObject } from "@/src/shared/types/any";
import { App, Component, createApp, h, provide } from "vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { createPinia } from "pinia";
import { getVuetify } from "@/src/easy-ui/plugins/vuetify";

export const buildAppInstance = ({
  component,
  rootContainer,
  setupCallback = () => provide(DefaultApolloClient, apolloClient),
  props,
}: {
  component: Component;
  rootContainer: Element | string;
  setupCallback?: () => void;
  props?: AnyObject;
}): App<Element> => {
  const app = createApp(
    {
      setup: () => setupCallback(),
      render: () => h(component),
    },
    { ...props }
  );
  app.use(createPinia());
  app.use(getVuetify());
  app.use(VueDOMPurifyHTML);
  app.mount(rootContainer);
  return app;
};
